var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNature(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.83287 15.3337H11.7612C14.6104 15.3337 17.1562 13.232 17.3945 10.3937C17.4943 9.25073 17.2293 8.10559 16.6376 7.12267C16.0459 6.13975 15.1579 5.36961 14.1012 4.92283C13.7654 2.24699 11.512 0.166992 8.74954 0.166992C5.98704 0.166992 3.7337 2.24699 3.39787 4.92283C2.34116 5.36961 1.45321 6.13975 0.861514 7.12267C0.269815 8.10559 0.0048047 9.25073 0.104534 10.3937C0.342867 13.232 2.8887 15.3337 5.73787 15.3337H7.6662V19.667H2.24953C1.6537 19.667 1.1662 20.1545 1.1662 20.7503C1.1662 21.3462 1.6537 21.8337 2.24953 21.8337H15.2495C15.8454 21.8337 16.3329 21.3462 16.3329 20.7503C16.3329 20.1545 15.8454 19.667 15.2495 19.667H9.83287V15.3337Z",
    fill: "#424242"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNature);
export default __webpack_public_path__ + "static/media/nature.1f9a5ecb.svg";
export { ForwardRef as ReactComponent };